__turbopack_context__.v({
  "container": "TemplateLibraryPage-module__0ma0TG__container",
  "content": "TemplateLibraryPage-module__0ma0TG__content",
  "mobileMenu": "TemplateLibraryPage-module__0ma0TG__mobileMenu",
  "mobileMenuContainer": "TemplateLibraryPage-module__0ma0TG__mobileMenuContainer",
  "mobileMenuIcon": "TemplateLibraryPage-module__0ma0TG__mobileMenuIcon",
  "mobileMenuToggle": "TemplateLibraryPage-module__0ma0TG__mobileMenuToggle",
  "showcaseTemplateContainer": "TemplateLibraryPage-module__0ma0TG__showcaseTemplateContainer",
  "sidebarContainer": "TemplateLibraryPage-module__0ma0TG__sidebarContainer",
  "templatesContainer": "TemplateLibraryPage-module__0ma0TG__templatesContainer",
});
